const buildMode = process.env.REACT_APP_BUILD_MODE ?? process.env.NODE_ENV ?? 'production';

const loginLinks = {
  development: 'https://admin-torneos-dev.liricus.com.ar/',
  production: 'https://admin.protorneos.com/',
} as const;

const registerLinks ={
  development: 'https://admin-torneos-dev.liricus.com.ar/auth/register',
  production: 'https://admin.protorneos.com/auth/register',
}

export function getLoginLink() {
  return buildMode === 'development' ? loginLinks.development : loginLinks.production;
}

export function getRegisterLink() {
  return buildMode === 'development' ? registerLinks.development : registerLinks.production;
}